import { Link } from "react-router-dom";
import { ArrowRight, SquaresFour } from "@phosphor-icons/react";
import { TOOLS } from "@/lib/tools";
import { AdSlot } from "@/components/AdSlot";
import { useSeo } from "@/lib/seo";

export default function Home() {
  useSeo("Free YouTube Creator Tools", "Thumbnail downloader, tag extractor, earnings calculator, hashtag generator and channel finder — free tools for YouTube creators.");
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-8 sm:py-12 lg:py-20">
      <div className="fade-up max-w-2xl">
        <p className="text-xs uppercase tracking-[0.2em] text-[var(--coral)] font-semibold mb-3 sm:mb-4">VidhFlow · Creator Toolkit</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05]">
          Grow your channel with <span className="text-[var(--glow)]">sharper tools</span>, not guesswork.
        </h1>
        <p className="text-[var(--muted)] text-sm sm:text-base mt-4 sm:mt-5 max-w-xl">
          Five free utilities every creator needs, plus a private dashboard to run scripts, sponsors and your filming calendar.
        </p>
        <div className="flex flex-wrap gap-3 mt-6 sm:mt-8">
          <Link
            to="/tools/thumbnail-downloader"
            data-testid="hero-tools-btn"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[var(--glow)] text-white font-semibold text-sm hover:bg-[#6a4ce6] transition-colors"
          >
            Try the tools <ArrowRight size={16} weight="bold" />
          </Link>
          <Link
            to="/dashboard"
            data-testid="hero-dashboard-btn"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full surface font-semibold text-sm hover:border-[var(--glow)] transition-colors"
          >
            <SquaresFour size={16} weight="duotone" /> Creator dashboard
          </Link>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-10 sm:mt-16">
        {TOOLS.map((t, i) => (
          <Link
            key={t.slug}
            to={t.path}
            data-testid={`home-tool-${t.slug}`}
            className={`surface rounded-[20px] p-6 lift block fade-up-${Math.min(i, 3)}`}
          >
            <span className="w-11 h-11 rounded-[12px] bg-[var(--glow)]/15 flex items-center justify-center">
              <t.icon size={22} color="var(--glow)" weight="duotone" />
            </span>
            <h3 className="font-bold text-lg mt-4">{t.name}</h3>
            <p className="text-[var(--muted)] text-sm mt-1.5">{t.desc}</p>
          </Link>
        ))}
      </div>
      <AdSlot id="home-footer" variant="multiplex" className="mt-16" />
    </div>
  );
}
